import { observer } from 'mobx-react-lite'
import { type ViewHeadingProps, ViewHeading } from '@/components/ViewHeading'
import { Dropdown } from '@/components/Dropdown'
import { SelectFilter } from '@/infra/SelectFilter'
import { SelectFilterViewContainer } from '@/components/FilterControls/Select/SelectFilterViewContainer'
import { type FilterViewModel } from '@/infra/FiltersViewModel'

interface WorkspaceFilterViewHeadingContainerProps extends Omit<
  ViewHeadingProps,
  'isDropdown' | 'secondaryText'
> {
  filter: FilterViewModel<string, unknown>
  allOptionText?: string
  testId?: string
}

/**
 * A view heading that opens a workspace filter as its dropdown.
 */
export const WorkspaceFilterViewHeadingContainer = observer(
  function WorkspaceFilterViewHeadingContainer({
    filter,
    allOptionText = 'All Workspaces',
    testId,
    ...rest
  }: WorkspaceFilterViewHeadingContainerProps) {
    if (!(filter instanceof SelectFilter)) {
      return <>Filter type not supported</>
    }

    const heading = (
      <ViewHeading
        {...rest}
        isDropdown={true}
        secondaryText={
          filter.value.length >= 1 ? filter.toString(1) : allOptionText
        }
      />
    )
    return (
      <Dropdown
        isOpen={filter.editing}
        position={'top-start'}
        onRequestClose={filter.stopEditing}
        onButtonPress={filter.startEditing}
        button={heading}
        testId={testId}
      >
        <SelectFilterViewContainer filter={filter} testId="job-select-filter" />
      </Dropdown>
    )
  },
)
